import { Component, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzIconDirective } from 'ng-zorro-antd/icon';

@Component({
  selector: 'beautyapp-agreement-view',
  imports: [
    NzListModule,
    NzTypographyComponent,
    NzButtonComponent,
    NzIconDirective,
    DatePipe
  ],
  templateUrl: './agreement-view.component.html',
  styleUrl: './agreement-view.component.scss'
})
export class AgreementViewComponent {
  userAgreements = signal<any[]>([]);
}
